import {EventFilter} from "../types/domain.ts";
import {useQuery} from "@tanstack/react-query";
import {eventsGet} from "../api/events/eventsGet.ts";

export const useEvents = (filter: EventFilter) => useQuery({
    queryKey: ['events', filter],
    queryFn: () => eventsGet(filter).then(r => r.payload),
})